import dayjs from 'dayjs';
import React, { useEffect } from 'react';

import Icons from '@/core/components/Icons';
import useDisclosure from '@/core/hooks/useDisclosure';
import { usePersistContext } from '@/core/lib/persist/persist.context';
import { useRouterContext } from '@/core/lib/router/router.context';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

const autoPromoLocalStorageKey = 'autoPromo';

interface AutoPromoProps {}

const AutoPromo: React.FC<AutoPromoProps> = () => {
  const { t } = useTranslationContext(['common']);
  const { Link } = useRouterContext();
  const { isOpen, onClose, onOpen } = useDisclosure(false);
  const { setLocal, getLocal, removeLocal } = usePersistContext();

  useEffect(() => {
    if (window.matchMedia('(width < 1024px)').matches) {
      onOpen();
      return;
    }

    getLocal(autoPromoLocalStorageKey).then(autoPromoOpenDate => {
      if (!autoPromoOpenDate || dayjs(autoPromoOpenDate).isBefore(dayjs())) {
        onOpen();
        removeLocal(autoPromoLocalStorageKey);
        return;
      }
    });
  }, []);

  if (!isOpen) {
    return null;
  }

  const handleOnClose = () => {
    const sevenDaysAfterToday = dayjs().add(7, 'days').toISOString();
    setLocal(autoPromoLocalStorageKey, sevenDaysAfterToday);
    onClose();
  };

  return (
    <section className="pointer-events-none sticky top-20 z-50 w-full max-w-[1344px] justify-end lg:fixed lg:bottom-28 lg:left-1/2 lg:top-auto lg:flex lg:-translate-x-1/2 xl:px-24">
      <div className="pointer-events-auto flex items-start justify-between bg-[#F9D8BA] p-3 lg:max-w-140 lg:translate-x-[200%] lg:animate-slideInRight lg:justify-normal lg:space-x-7 lg:rounded-2 lg:p-6">
        <img src="/assets/appQRcode.png" alt={t('components.pre-footer.qr-code-alt', { ns: 'common' })} className="hidden w-30 lg:block" />
        <div className="space-y-2 sm:mx-auto lg:space-y-3">
          <p className="text-16 font-semibold lg:whitespace-pre-wrap lg:text-25">{t('components.auto-promo.title', { ns: 'common' })}</p>
          <div className="flex space-x-2">
            <Link href={new Routes.ExternalRoute('appStore')} target="_blank" className="w-35">
              <img src="/assets/socialNetwork/app-store-black.png" alt={t('social-network.app-store-alt', { ns: 'common' })} />
            </Link>
            <Link href={new Routes.ExternalRoute('playStore')} target="_blank" className="w-35">
              <img src="/assets/socialNetwork/google-play-black.png" alt={t('social-network.play-store-alt', { ns: 'common' })} />
            </Link>
          </div>
        </div>
        <Icons icon="close" weight="bold" className="flex size-4 rounded-full bg-[white] p-[2px] hover:bg-bg-secondary" onClick={handleOnClose} />
      </div>
    </section>
  );
};

export default AutoPromo;
